import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { NavLink, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import css from '../../../../../css/css-variables';
import {
  LIFEWAY_COM_URL,
  PATH_DIGITAL_MEDIA,
  PATH_LOGGED_OUT,
  PATH_ORDER_HISTORY,
  PATH_PROFILE,
} from '../../../constants';
import AccessibleText from '../../AccessibleText';
import CartIcon from '../../../../../img/sprite/cart-icon.svg';
import ProfilesList from './ProfilesList';
import NameMessage from './NameMessage';

const MobileNavWrapper = styled.div`
  background-color: white;
  border-bottom: 2px solid ${css.colors.AccentGray};
  padding: 0 0.5rem 0.5rem 0.5rem;
`;

const MobileNav = styled.nav`
  background-color: white;
  overflow: hidden;
  padding: 0.25rem 1rem 0 1rem;
  text-align: right;
`;

const Separator = styled.div`
  height: 2px;
  background-color: ${css.colors.LifewayComDecorationGray};
  margin: 0.2rem 0rem;
`;

const LinksList = styled.ul`
  margin: 0.75rem 0rem;
  & button,
  & a {
    width: 100%;
    padding: 0.45rem 0.5rem;
    margin: 0.2rem 0;
    background-color: transparent;
    text-decoration: none;
    text-align: unset;
    color: #414042;
  }
  & button {
    border: none;
  }
  & a span {
    padding: 0.2rem 0rem;
    border-bottom: 2px solid transparent;
  }
  & li a.active span {
    border-bottom: 2px solid #fdb528;
    font-weight: bold;
  }
`;

const CartSVG = styled.svg`
  margin-right: 0.5em;
  height: 1.25em;
  width: 1.25em;
  position: relative;
  top: -1px;
`;

const MobileAccountMenu = ({ closeMenu, onLogOut }) => {
  const history = useHistory();
  const name = useSelector(state => {
    const first = state.app.getIn(['currentUser', 'firstName']);
    const last = state.app.getIn(['currentUser', 'lastName']);
    return first != null && first !== '' ? first : last;
  });

  const logout = () => {
    closeMenu();
    onLogOut();
    history.push(PATH_LOGGED_OUT);
  };

  return (
    <MobileNavWrapper>
      <MobileNav id="account-menu-mobile" aria-label="Account Options">
        <NameMessage>Hello, {name}</NameMessage>
        <Separator />
        <LinksList>
          <li>
            <NavLink to={PATH_PROFILE} onClick={closeMenu}>
              <span>My Account</span>
            </NavLink>
          </li>
          <li>
            <NavLink to={PATH_ORDER_HISTORY} onClick={closeMenu}>
              <span>My Order History</span>
            </NavLink>
          </li>
          <li>
            <NavLink to={PATH_DIGITAL_MEDIA} onClick={closeMenu}>
              <span>My Digital Media</span>
            </NavLink>
          </li>
          <li>
            <button type="button" onClick={logout}>
              Logout
            </button>
          </li>
        </LinksList>
        <Separator />
        <LinksList>
          <li>
            <a href={`${LIFEWAY_COM_URL}/en/checkout/shopping-cart`}>
              <CartSVG role="presentation">
                <use href={`#${CartIcon.id}`} xlinkHref={`#${CartIcon.id}`} />
              </CartSVG>
              <span>View My Cart</span>
            </a>
          </li>
          <li>
            <a href={LIFEWAY_COM_URL}>Keep Shopping</a>
          </li>
        </LinksList>
        <AccessibleText as="button" tabIndex="-1" onClick={closeMenu}>
          Close
        </AccessibleText>
      </MobileNav>
      <ProfilesList onLinkClick={closeMenu} />
    </MobileNavWrapper>
  );
};

const { func } = PropTypes;

MobileAccountMenu.propTypes = {
  closeMenu: func.isRequired,
  onLogOut: func.isRequired,
};

export default MobileAccountMenu;